var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"header"},[_vm._t("header"),_c('div',{staticClass:"body-1 grey-darken-2"},[_vm._t("subheader")],2)],2),_c('section',{staticClass:"body-large-1"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }